<script setup lang="ts">
import { mdiEye, mdiEyeOff } from '@mdi/js';
import VeeTextField from '@/components/forms/TextField/VeeTextField.vue';
import type { VeePasswordFieldProps } from '../types';

const show = defineModel('show', { type: Boolean, default: false });

const props = defineProps<VeePasswordFieldProps>();
</script>

<template>
  <VeeTextField
    v-bind="props"
    :type="show ? 'text' : 'password'"
    :appendInnerIcon="show ? mdiEyeOff : mdiEye"
    @click:appendInner="show = !show"
  />
</template>
